import { render } from "./fullCircleIcon.svg?vue&type=template&id=7b32fe3e"
const script = {}
script.render = render

export default script